/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { apiResponseV4Schema } from './apiResponseV4Schema'

export const authLogoutStatus200Schema = apiResponseV4Schema.describe(
  'V4 response envelope — same contract as the legacy EP.Models.ViewModels.ApiResponse minus the dead\r\n`planNeeded` field. V4 endpoints must never expose `planNeeded`; legacy endpoints keep\r\nthe old envelope untouched.'
)

export const authLogoutResponseSchema = authLogoutStatus200Schema
